<template>
    <div>
        <div class="az-form-content">
            <p v-if="itensELotes.lotes.length === 0
              && itensELotes.itens.length === 0"
               class="mensagem-quando-vazio">
                Não há itens para esta compra direta.
            </p>

            <div v-else>
                <painel-lote-visualizacao v-if="itensELotes.lotes.length > 0"
                                          v-model="itensELotes.lotes"
                                          :possuiValorReferencia="resumoCompraDireta.possuiValorReferencia"
                                          :prefixOuSuffixValor="prefixOuSuffixValor"
                                          :criterioJulgamento="criterioJulgamento"
                                          :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                                          :casasDecimais="itensELotes.casaDecimal"
                                          :casasDecimaisQuantidade="itensELotes.casasDecimaisQuantidade"/>

                <painel-item-visualizacao v-if="itensELotes.itens.length > 0"
                                          v-model="itensELotes.itens"
                                          :possuiValorReferencia="resumoCompraDireta.possuiValorReferencia"
                                          :prefixOuSuffixValor="prefixOuSuffixValor"
                                          :criterioJulgamento="criterioJulgamento"
                                          :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                                          :casasDecimais="itensELotes.casaDecimal"
                                          :casasDecimaisQuantidade="itensELotes.casasDecimaisQuantidade"/>

                <div class="total ma-0" v-if="resumoCompraDireta.possuiValorReferencia && !isCriterioJulgamentoMaiorDesconto && (itensELotes.itens.length > 0 && itensELotes.lotes.length > 0)">
                    <p>
                        <strong>Total Geral:</strong> {{ totalGeral | cdCurrency(prefix, itensELotes.casaDecimal) }}{{suffix}}
                    </p>
                </div>
            </div>
        </div>

        <div class="az-actions-form ajuste-acoes">
            <botao-voltar @voltar="tratarEventoVoltar"/>
            <botao-avancar @avancar="tratarEventoAvancar"/>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import {actionTypes, criteriosJulgamento} from '@/core/constants'
import PainelLoteVisualizacao from '@/views/pages/comprador/execucao-compra-direta/itens-lotes/painel-lote/PainelLoteVisualizacao'
import PainelItemVisualizacao from '@/views/pages/comprador/execucao-compra-direta/itens-lotes/painel-item/PainelItemVisualizacao'
import BotaoAvancar from '@/views/components/BotaoAvancar'
import BotaoVoltar from '@/views/components/BotaoVoltar'

export default {
    name: 'ItensLotesEdicao',
    components: {
        BotaoVoltar,
        BotaoAvancar,
        PainelItemVisualizacao,
        PainelLoteVisualizacao
    },
    data() {
        return {
            compraDiretaId: null
        }
    },
    computed: {
        ...mapState(['itensELotes', 'parametros', 'resumoCompraDireta']),
        totalGeral() {
            let totalItens = 0
            let totalLotes = 0
            this.itensELotes.itens.forEach(item => {
                if (item.totalEstimado > 0) {
                    totalItens += item.totalEstimado
                }
            })
            this.itensELotes.lotes.forEach(lote => {
                if (lote.totalGeral > 0) {
                    totalLotes += lote.totalGeral
                }
            })
            return totalItens + totalLotes
        },
        prefixOuSuffixValor(){
            return this.resumoCompraDireta.prefixoValor
        },
        criterioJulgamento(){
            return this.resumoCompraDireta.criterioJulgamento
        },
        isCriterioJulgamentoMaiorDesconto(){
            return this.resumoCompraDireta.criterioJulgamento === criteriosJulgamento.MAIOR_DESCONTO.valor
        },
        prefix(){
            return this.resumoCompraDireta.prefixoValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.resumoCompraDireta.prefixoValor === '%' ? '%' : ''
        }
    },
    async mounted() {
        try {
            this.setCompraDiretaId()
            await this.buscarItensLotes()
            await this.buscarCompraDireta()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarItensLotes() {
            await this.$store.dispatch(actionTypes.BUSCAR_ITENS_E_LOTES, this.compraDiretaId)
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        },
        tratarEventoVoltar() {
            this.$router.push({name: 'DadosGeraisVisualizacao', params: this.compraDiretaId})
        },
        tratarEventoAvancar() {
            this.$router.push({name: 'DocumentosVisualizacao', params: this.compraDiretaId})
        },
        async buscarCompraDireta(){
            await this.$store.dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, this.compraDiretaId)
        }
    }
}
</script>

<style scoped lang="stylus">
    .az-actions-form
        padding 0
</style>